import DOMPurify from 'dompurify';

export function renderHTML(html, shouldSanitize = true) {
    if (shouldSanitize) {
      return { __html: DOMPurify.sanitize(html) };
    }
    return { __html: html };
}